$body.on("mousedown","[href][data-page-transition]",function(e){
    //alert("glop")
    $body.attr("data-page-transition",$(this).attr("data-page-transition"))
});


// WEBPACK FOOTER //
// ./project/_src/layout/data-page-transition.js